import React, { useEffect, useState } from 'react'
import "../styles/notification.css"
import axios from 'axios'
import { Link } from 'react-router-dom'
import moment from 'moment'
import HdrStrongIcon from '@mui/icons-material/HdrStrong';
import { Skeleton } from '@mui/material'
export default function Notification({propsData}) {

    let [AllNotifications,GetAllNotifications]=useState([])
    let [AllNotificationsError,GetAllNotificationsError]=useState(false)
    let [AllNotificationsLoad,GetAllNotificationsLoad]=useState(false)
  
    useEffect(()=>{
      GetAllNotificationsLoad(true)
      GetAllNotificationsError(true)
      axios.get(`${process.env.REACT_APP_URL}/api/notifications/GetShopNotifications/${propsData.currentShope}`, //proxy uri
      {
         headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
         } 
      })
      .then(res=>{
        //console.log(res.data);
        GetAllNotifications(res.data)
        GetAllNotificationsLoad(false)
        GetAllNotificationsError(false)
      })
      .catch(error=>{
        console.log(error);
        GetAllNotificationsLoad(false)
        GetAllNotificationsError(true)
      })
    },[])

    let sampleNotif=[1,2,3,4,5,6]

    let groupedNotifications = {};

  //  useEffect(()=>{
      if(AllNotifications.length>0){
          for (const notification of AllNotifications) {
            const formattedDate = moment(notification.createdAt).format('YYYY-MM-DD');
            if (!groupedNotifications[formattedDate]) {
              groupedNotifications[formattedDate] = [];
            }
            groupedNotifications[formattedDate].push(notification);
          }
      }
      
   // },[AllNotifications])

  return (
    <div className='notifications'>
        <h2>Notifications</h2>
        <div  className='notificationsList'>
             <div className='notificationsListContainer'>

               {AllNotificationsError?
                   <div style={{overflow:"hidden"}}>
                       {sampleNotif.map(e=>{
                         return  <Skeleton key={e} animation="wave" height={50} width="100%" />
                       })}
                   </div>
                :<>
                  {AllNotifications.length===0&&<div style={{margin:"100px 0 0px 0",textAlign:"center",opacity:0.5}}>No notification is exist</div>}
                  {Object.keys(groupedNotifications).map((date) => (
                    <>
                      <div style={{textAlign:"center",fontSize:"14px",fontWeight:"700",opacity:0.4,marginTop:"5px"}}>{moment(date).format('dddd, MMMM Do')}</div>
                      {groupedNotifications[date].map((notification) => (
                        <EachNotifications item={notification} key={notification._id} propsData={propsData} />
                      ))}
                    </>
                  ))}
                
                </>
}

             </div>
        </div>

        <div className='notificationsList'>
         
        </div>
        
    </div>
  )
}

const EachNotifications=({item,propsData})=>{


  return(
    <Link to={`${item.link}`} style={{color:"inherit",textDecoration:"none"}}>
            <div className='notificationsListEach'>
                    <div style={{display:"flex",justifyContent:"flex-start",alignItems:"center",gap:"6px"}}> 
                       <div><HdrStrongIcon style={{color:"red"}}/></div>
                       {item?.content&&<div  dangerouslySetInnerHTML={{ __html: item.content }}/>}
                    </div>
                    <div style={{opacity:0.6,marginTop:"2px",fontSize:"11px",textAlign:"end"}}> {moment(item.createdAt).format('LT')}</div>
            </div>
    </Link>
  )
}